// Non-dismissible fullscreen hard-block shown when the current browser isn't
// Chromium-based. Rendered by ToolLayout INSTEAD of the talent app, before any
// config loads, so no WebAudio code path can execute on an unsupported browser.
// /admin is unaffected (mounted outside ToolLayout). Detection lives in
// `src/lib/browserSupport.ts`.

import styles from './BrowserGate.module.css';

export function BrowserGate() {
  return (
    <div
      className={styles.guard}
      role="dialog"
      aria-modal="true"
      aria-labelledby="browser-gate-title"
    >
      <div className={styles.card}>
        <i className={`ph-bold ph-browser ${styles.icon}`} aria-hidden="true" />
        <h1 className={styles.title}>Voice Studio</h1>
        <p id="browser-gate-title" className={styles.lead}>
          Please use a Chrome browser
        </p>
        <p className={styles.sub}>Google Chrome, Edge, Brave, Arc or similar.</p>
      </div>
    </div>
  );
}
